import React from 'react';
import {Modal} from 'antd';

import PostForm, {PostFormTypes} from '~/components/Bulletin/PostForm/PostForm';

export default function NewPostModal({cancel, postCreated, isPreview, description, attachments}) {
    const handleCancel = () => {
        if (cancel) cancel();
    }

    const handlePostCreated = (post) => {
        if (postCreated) postCreated(post);
    }

    return (
        (<Modal
            title={null}
            footer={null}
            open={true}
            closable={false}
            maskClosable={false}
            maskTransitionName="maskTransitionName"
            width={750}
            style={{top: "50px"}}
        >
            <PostForm
                formType={PostFormTypes.NEW_POST_MODAL}
                onCancel={handleCancel}
                onPostCreated={handlePostCreated}
                isPreview={isPreview}
                initialBody={description}
                initialAttachments={attachments}
            />
        </Modal>)
    );
}
